import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "square",
      "stroke-width": "2",
      d: "M1 17h5.5m-1-15.5H11"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 17 7.686 1H10L4.314 17z"
    }, null, -1)
  ]))]))
}
export default { render: render }